import ctx from "../../plugins/axios";

// eslint-disable-next-line import/no-anonymous-default-export
export default async () => {
  return await ctx.get("/admin/product_bu?product_bu=true");
};
